// Shared cell-editing helpers for TOB tables. Cell data is stored as
// { [rowNum]: { '1': { cell_value, cell_bg_color, cell_text_color, font_weight, ... } } }.

export function patchCell(table, rowNum, patch) {
    const rowKey = String(rowNum);
    const currentRow = table?.[rowKey];
    const existingCell = (currentRow && typeof currentRow === 'object' && (currentRow['1'] || currentRow)) || {};

    return {
        ...(table || {}),
        [rowKey]: { ...(currentRow || {}), '1': { ...existingCell, ...patch } },
    };
}

// Formatting from the menu bar. A TOB's cells come with the template's own colours (the
// navy header rows, shaded section titles), so the first time a style is changed the cell's
// value is kept under original_styles, and clearing it (an undefined value) puts that back
// instead of dropping to plain white/black.
export function patchCellStyle(table, rowNum, patch) {
    const cell = readCell(table, rowNum) || {};
    const originalStyles = { ...(cell.original_styles || {}) };
    const styles = {};

    Object.entries(patch).forEach(([key, value]) => {
        if (!(key in originalStyles)) originalStyles[key] = cell[key] ?? null;
        styles[key] = value === undefined ? (originalStyles[key] ?? undefined) : value;
    });

    return patchCell(table, rowNum, { ...styles, original_styles: originalStyles });
}

export function readCell(column, rowNum) {
    const rowData = column?.[String(rowNum)];
    return rowData?.['1'] || rowData || null;
}

// The table renders font_weight straight into CSS, so anything from 600 up already looks
// bold there and toggling has to agree with what the user sees.
export function isBoldCell(cell) {
    const weight = cell?.font_weight;
    return weight === 'bold' || Number(weight) >= 600;
}
